export default __webpack_public_path__ + "static/sugbologo-1ff0519d81fd8b6956048a3cf29c8a62.png";